import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navItems = [{
  label: 'Inicio',
  href: 'hero'
}, {
  label: 'El Libro',
  href: 'about'
}, {
  label: 'Contenido',
  href: 'content'
}, {
  label: '¿Para Quién?',
  href: 'audience'
}, {
  label: 'Precio',
  href: 'pricing-section'
}, {
  label: 'FAQ',
  href: 'faq'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (sectionId: string) => {
    // Close mobile menu first
    setIsMobileMenuOpen(false);
    // Small delay to allow menu to close before scrolling
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 70;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg shadow-black/20' : 'bg-[#0a0a0a]/80 backdrop-blur-sm'}`} data-id="element-17">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="flex items-center justify-between h-14 sm:h-16" data-id="element-19">
          {/* Logo */}
          <button onClick={() => scrollToSection('hero')} className="text-white font-serif text-lg sm:text-xl font-bold tracking-tight" data-id="element-20">
            VENEZUELA
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1" data-id="element-21">
            {navItems.map(item => <button key={item.href} onClick={() => scrollToSection(item.href)} className="px-3 py-2 text-sm text-zinc-400 hover:text-white transition-colors rounded-lg hover:bg-zinc-800/50" data-id="element-22">
                {item.label}
              </button>)}
            <button onClick={() => scrollToSection('pricing-section')} className="ml-2 px-4 py-2 bg-[#FFCC00] hover:bg-[#e6b800] text-[#0a0a0a] text-sm font-bold rounded-lg transition-all" data-id="element-23">
              Comprar
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 text-zinc-400 hover:text-white transition-colors" data-id="element-24">
            {isMobileMenuOpen ? <X size={24} data-id="element-25" /> : <Menu size={24} data-id="element-26" />}
          </button>
        </div>
      </div>

      {/* Flag stripe at bottom of header */}
      <div className="flex h-1" data-id="element-27">
        <div className="flex-1 bg-[#FFCC00]" data-id="element-28"></div>
        <div className="flex-1 bg-[#00247D]" data-id="element-29"></div>
        <div className="flex-1 bg-[#CF142B]" data-id="element-30"></div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-31">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2
      }} className="md:hidden bg-[#0a0a0a]/98 backdrop-blur-md border-t border-zinc-800" data-id="element-32">
            <nav className="px-4 py-4 space-y-1" data-id="element-33">
              {navItems.map(item => <button key={item.href} onClick={() => scrollToSection(item.href)} className="block w-full text-left px-4 py-3 text-zinc-300 hover:text-white hover:bg-zinc-800/50 rounded-lg transition-colors" data-id="element-34">
                  {item.label}
                </button>)}
              <button onClick={() => scrollToSection('pricing-section')} className="block w-full mt-4 px-4 py-3 bg-[#FFCC00] hover:bg-[#e6b800] text-[#0a0a0a] font-bold rounded-lg transition-all text-center" data-id="element-35">
                Comprar Ahora — $14.97
              </button>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}